import { phone } from 'phone';

export default function validatePhoneNumber(value: string, country?: string) {
  return phone(value, {
    country,
    validateMobilePrefix: false,
    strictDetection: true,
  });
}
